/**
 * Which Prompt Library prompts fit the Ads AI (Shawn, 2026-10-28: "at least those
 * prompts that are meant for PPC and LSA ads"; Meta ads too since it reads Facebook, 2026-11-02). The library has no platform field, so a
 * prompt fits when it talks about Google Ads work and its name is not about another
 * channel. No imports and only erasable types, so node --test loads it.
 */
type Prompt = { prompt_name: string; prompt_body: string };

const ADS_WORK = /google ads|meta ads|facebook ads|instagram ads|\bppc\b|\blsa\b|local services|search campaign|\brsa\b|search terms?|keywords?|quality score|impression share|performance max|\bpmax\b|smart bidding|negative/i;
const OTHER_CHANNEL = /linkedin|tiktok|youtube|midjourney|kling|runway|elevenlabs|\bseo\b|\bgbp\b|content calendar|review response|negative review|offboarding|crisis|quarterly business review/i;

export function isAdsPrompt(p: Prompt): boolean {
  return ADS_WORK.test(`${p.prompt_name} ${p.prompt_body}`) && !OTHER_CHANNEL.test(p.prompt_name);
}
